import {Component} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute} from "@angular/router";
import {InteractionService} from "../../service/interaction.service";

@Component({
    selector: 'ci-interaction-types-page',
    templateUrl: './interaction-types.page.html',
})
export class InteractionTypesPage extends CorePage {

    override defaultLabel: string = "Home";

    constructor(
        protected override route: ActivatedRoute,
        protected interactionService: InteractionService
    ) {
        super(route);

    }

  override ngOnInit() {
    super.ngOnInit();

    // initialize the interaction service
    this.interactionService.initialize();

  }




}
